import { render, staticRenderFns } from "./CrearGeneral.vue?vue&type=template&id=f90eafc6&scoped=true&"
import script from "./CrearGeneral.vue?vue&type=script&lang=ts&"
export * from "./CrearGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./CrearGeneral.vue?vue&type=style&index=0&id=f90eafc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90eafc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f90eafc6', component.options)
    } else {
      api.reload('f90eafc6', component.options)
    }
    module.hot.accept("./CrearGeneral.vue?vue&type=template&id=f90eafc6&scoped=true&", function () {
      api.rerender('f90eafc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/CrearGeneral.vue"
export default component.exports